import { createEvent, createStore, sample } from 'effector'
import { fx, Request } from '../../../../libs/request'
import { WalletGuardWallet } from '../../types'

export const walletRequested = createEvent<number>()

export const getWalletFx = fx<void, WalletGuardWallet>({ method: 'GET' })

const $latestRequest = createStore<Request<void> | null>(null).on(
  getWalletFx,
  (_, params) => params,
)

const walletReceived = createEvent<WalletGuardWallet>()
const walletFailed = createEvent()

export const $wallet = createStore<WalletGuardWallet | null>(null)
  .on(walletReceived, (_, wallet) => wallet)
  .reset(getWalletFx)

export const $walletHasError = createStore(false)
  .on(walletFailed, () => true)
  .reset(getWalletFx)

sample({
  clock: walletRequested,
  fn: (walletId) => ({ url: `/wallet-guard/wallets/${walletId}` }),
  target: getWalletFx,
})

sample({
  clock: getWalletFx.done,
  source: $latestRequest,
  filter: (latest, { params }) => latest === params,
  fn: (_, { result }) => result.body,
  target: walletReceived,
})

sample({
  clock: getWalletFx.fail,
  source: $latestRequest,
  filter: (latest, { params }) => latest === params,
  fn: () => undefined,
  target: walletFailed,
})
